// Chakra imports
import {
	Flex,
	Select,
	HStack,
	SimpleGrid,
	useColorModeValue,
} from "@chakra-ui/react";
// assets
import BarChart from "components/Charts/BarChart";
// Custom icons
import {
	CartIcon,
	DocumentIcon,
	GlobeIcon,
	WalletIcon,
} from "components/Icons/Icons.js";
import React from "react";
import ActiveUsers from "./components/ActiveUsers";
import MiniStatistics from "./components/MiniStatistics";
import Request from "assets/svg/request-icon.svg";
import Success from "assets/svg/success-icon.svg";
import Errors from "assets/svg/errors-icon.svg";

export default function Dashboard() {
	const iconBoxInside = useColorModeValue("white", "white");
	const selectBg = "#33333B";

	return (
		<Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
			<HStack mb={5} spacing={5} justify="flex-end" w="full">
				<Select
					placeholder="All Apis"
					h="60px"
					borderRadius="16px"
					w="300px"
					bg={selectBg}
				>
					<option value="option1">Option 1</option>
					<option value="option2">Option 2</option>
					<option value="option3">Option 3</option>
				</Select>
				<Select
					placeholder="All Indexes"
					h="60px"
					borderRadius="16px"
					w="300px"
					bg={selectBg}
				>
					<option value="option1">Option 1</option>
					<option value="option2">Option 2</option>
					<option value="option3">Option 3</option>
				</Select>
				<Select
					placeholder="year"
					h="60px"
					borderRadius="16px"
					w="150px"
					bg={selectBg}
				>
					<option value="option1">Option 1</option>
					<option value="option2">Option 2</option>
					<option value="option3">Option 3</option>
				</Select>
			</HStack>
			<SimpleGrid columns={{ sm: 1, md: 3, xl: 3 }} spacing="24px">
				<MiniStatistics
					title={"Today's Users"}
					amount={"2,300"}
					percentage={5}
					icon={Request}
				/>
				<MiniStatistics
					title={"New Clients"}
					amount={"+3,020"}
					percentage={-14}
					icon={Success}
				/>
				<MiniStatistics
					title={"Total Sales"}
					amount={"$173,000"}
					percentage={8}
					icon={Errors}
				/>
			</SimpleGrid>
			<Flex>
				<ActiveUsers
					title={"Active Users"}
					percentage={23}
					chart={<BarChart />}
				/>
			</Flex>
		</Flex>
	);
}
